import React from 'react'

const JobCardGlow = () => {
    return (
        Array.from({ length: 10 }).map((_, i) => (
            <div className="card w-100 mt-2 rounded-4 border-0" key={i}>
                <div className="card-body ">
                    <div className="d-flex align-items-center my-2">
                        <div className="flex-shrink-0">
                            <img src={``} alt="..." width={90} height={90} className='pe-none placeholder rounded-circle' />
                        </div>
                        <div className="flex-grow-1 ms-3">
                            <p className="job-card-posted-time placeholder col-5 rounded py-3"></p>
                            <h6 className="job-card-component-heading placeholder col-8 rounded py-2 pt-3">Placeholder</h6>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between card-company-details-icon mt-4">
                        <label className="fs-7 card-inner-details col-3">
                            <span className="placeholder rounded py-2 pt-3 w-100"></span>
                        </label>
                        <label className="fs-7 card-inner-details col-2">
                            <span className="placeholder rounded py-2 pt-3 w-100"></span>
                        </label>
                        <label className="fs-7 card-inner-details col-2">
                            <span className="placeholder rounded py-2 pt-3 w-100"></span>
                        </label>
                        <label className="fs-7 card-inner-details col-2">
                            <span className="placeholder rounded py-2 pt-3 w-100"></span>
                        </label>
                    </div>
                    <p className="mt-4 job-card-description placeholder rounded skeleton-jobParagraph col-12">
                        {" "}
                    </p>
                </div>
            </div>
        ))
    )
}

export default JobCardGlow